import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, description, testId }) => {
  return (
    <section data-testid={testId} className="relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 bg-butter-soft blob-shape opacity-70 pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-80 h-80 bg-teal-soft blob-shape-alt opacity-70 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
          className="max-w-3xl"
        >
          {eyebrow && (
            <span data-testid={`${testId}-eyebrow`} className="inline-block bg-teal-soft text-teal-dark font-extrabold text-xs uppercase tracking-[0.18em] px-4 py-2 rounded-full mb-5">
              {eyebrow}
            </span>
          )}
          {title && (
            <h1 data-testid={`${testId}-title`} className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-navy tracking-tight text-balance">
              {title.split(/(thriv\w*)/i).map((part, i) =>
                part.toLowerCase().startsWith("thriv") ? (
                  <span key={i} className="text-turquoise">{part}</span>
                ) : (
                  part
                )
              )}
            </h1>
          )}
          {description && (
            <p data-testid={`${testId}-description`} className="mt-5 text-base sm:text-lg text-navy-light leading-relaxed max-w-2xl">
              {description}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};
